module.exports = __webpack_public_path__ + "media/images/riders/small/GITTHA_MICHIELS-ee70b954404a31e8b4fc2d09a9980dad.png";